<template>
  <span class="section__header">{{ text }}</span>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>
